export interface OverlayFontDefinition {
  value: string;
  label: string;
  family: string;
  group: "Core" | "Poster & impact" | "Digital & sci-fi" | "Editorial & script";
  googleFamily?: string;
}

export const OVERLAY_FONTS = [
  { value: "sans", label: "Sans (modern)", family: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", system-ui, sans-serif', group: "Core" },
  { value: "display", label: "Display (chunky)", family: '"Bebas Neue", "Oswald", "Impact", "Arial Black", system-ui, sans-serif', group: "Core" },
  { value: "serif", label: "Serif (editorial)", family: '"Playfair Display", "Georgia", "Times New Roman", serif', group: "Core" },
  { value: "mono", label: "Mono (technical)", family: '"JetBrains Mono", "SF Mono", ui-monospace, monospace', group: "Core" },
  { value: "gf-bebasneue", label: "Bebas Neue (poster)", family: '"Bebas Neue", sans-serif', group: "Poster & impact", googleFamily: "Bebas Neue" },
  { value: "gf-anton", label: "Anton (heavy headline)", family: '"Anton", sans-serif', group: "Poster & impact", googleFamily: "Anton" },
  { value: "gf-oswald", label: "Oswald (clean condensed)", family: '"Oswald", sans-serif', group: "Poster & impact", googleFamily: "Oswald" },
  { value: "gf-bungee", label: "Bungee (chunky tag)", family: '"Bungee", sans-serif', group: "Poster & impact", googleFamily: "Bungee" },
  { value: "gf-bungeeshade", label: "Bungee Shade (3D)", family: '"Bungee Shade", sans-serif', group: "Poster & impact", googleFamily: "Bungee Shade" },
  { value: "gf-bowlby", label: "Bowlby One (round bold)", family: '"Bowlby One", sans-serif', group: "Poster & impact", googleFamily: "Bowlby One" },
  { value: "gf-blackops", label: "Black Ops One", family: '"Black Ops One", sans-serif', group: "Poster & impact", googleFamily: "Black Ops One" },
  { value: "gf-shrikhand", label: "Shrikhand (poster italic)", family: '"Shrikhand", sans-serif', group: "Poster & impact", googleFamily: "Shrikhand" },
  { value: "gf-fugaz", label: "Fugaz One", family: '"Fugaz One", sans-serif', group: "Poster & impact", googleFamily: "Fugaz One" },
  { value: "gf-righteous", label: "Righteous (clean tag)", family: '"Righteous", sans-serif', group: "Poster & impact", googleFamily: "Righteous" },
  { value: "gf-russo", label: "Russo One (impact)", family: '"Russo One", sans-serif', group: "Poster & impact", googleFamily: "Russo One" },
  { value: "gf-archivoblack", label: "Archivo Black (bold editorial)", family: '"Archivo Black", sans-serif', group: "Poster & impact", googleFamily: "Archivo Black" },
  { value: "gf-staatliches", label: "Staatliches (tall poster)", family: '"Staatliches", sans-serif', group: "Poster & impact", googleFamily: "Staatliches" },
  { value: "gf-alfaslab", label: "Alfa Slab One (festival)", family: '"Alfa Slab One", serif', group: "Poster & impact", googleFamily: "Alfa Slab One" },
  { value: "gf-unbounded", label: "Unbounded (wide future)", family: '"Unbounded", sans-serif', group: "Poster & impact", googleFamily: "Unbounded" },
  { value: "gf-pressstart", label: "Press Start 2P (retro)", family: '"Press Start 2P", monospace', group: "Digital & sci-fi", googleFamily: "Press Start 2P" },
  { value: "gf-vt323", label: "VT323 (terminal)", family: '"VT323", monospace', group: "Digital & sci-fi", googleFamily: "VT323" },
  { value: "gf-majormono", label: "Major Mono (typewriter)", family: '"Major Mono Display", monospace', group: "Digital & sci-fi", googleFamily: "Major Mono Display" },
  { value: "gf-monoton", label: "Monoton (neon line)", family: '"Monoton", sans-serif', group: "Digital & sci-fi", googleFamily: "Monoton" },
  { value: "gf-audiowide", label: "Audiowide (sci-fi)", family: '"Audiowide", sans-serif', group: "Digital & sci-fi", googleFamily: "Audiowide" },
  { value: "gf-orbitron", label: "Orbitron (space)", family: '"Orbitron", sans-serif', group: "Digital & sci-fi", googleFamily: "Orbitron" },
  { value: "gf-nabla", label: "Nabla (chrome 3D)", family: '"Nabla", sans-serif', group: "Digital & sci-fi", googleFamily: "Nabla" },
  { value: "gf-cutivemono", label: "Cutive Mono", family: '"Cutive Mono", monospace', group: "Digital & sci-fi", googleFamily: "Cutive Mono" },
  { value: "gf-oxanium", label: "Oxanium (techno)", family: '"Oxanium", sans-serif', group: "Digital & sci-fi", googleFamily: "Oxanium" },
  { value: "gf-syncopate", label: "Syncopate (cinematic sci-fi)", family: '"Syncopate", sans-serif', group: "Digital & sci-fi", googleFamily: "Syncopate" },
  { value: "gf-michroma", label: "Michroma (space console)", family: '"Michroma", sans-serif', group: "Digital & sci-fi", googleFamily: "Michroma" },
  { value: "gf-brunoace", label: "Bruno Ace SC (arcade future)", family: '"Bruno Ace SC", sans-serif', group: "Digital & sci-fi", googleFamily: "Bruno Ace SC" },
  { value: "gf-cinzel", label: "Cinzel (Roman serif)", family: '"Cinzel", serif', group: "Editorial & script", googleFamily: "Cinzel" },
  { value: "gf-cinzeldec", label: "Cinzel Decorative", family: '"Cinzel Decorative", serif', group: "Editorial & script", googleFamily: "Cinzel Decorative" },
  { value: "gf-playfair", label: "Playfair Display", family: '"Playfair Display", serif', group: "Editorial & script", googleFamily: "Playfair Display" },
  { value: "gf-caveat", label: "Caveat (handwriting)", family: '"Caveat", cursive', group: "Editorial & script", googleFamily: "Caveat" },
  { value: "gf-permamarker", label: "Permanent Marker", family: '"Permanent Marker", cursive', group: "Editorial & script", googleFamily: "Permanent Marker" },
  { value: "gf-pacifico", label: "Pacifico (brush script)", family: '"Pacifico", cursive', group: "Editorial & script", googleFamily: "Pacifico" },
  { value: "gf-lobster", label: "Lobster (vintage script)", family: '"Lobster", cursive', group: "Editorial & script", googleFamily: "Lobster" },
  { value: "gf-greatvibes", label: "Great Vibes (calligraphy)", family: '"Great Vibes", cursive', group: "Editorial & script", googleFamily: "Great Vibes" },
  { value: "gf-sacramento", label: "Sacramento (signature)", family: '"Sacramento", cursive', group: "Editorial & script", googleFamily: "Sacramento" },
  { value: "gf-dancing", label: "Dancing Script", family: '"Dancing Script", cursive', group: "Editorial & script", googleFamily: "Dancing Script" },
  { value: "gf-special", label: "Special Elite", family: '"Special Elite", serif', group: "Editorial & script", googleFamily: "Special Elite" },
  { value: "gf-yeseva", label: "Yeseva One", family: '"Yeseva One", serif', group: "Editorial & script", googleFamily: "Yeseva One" },
  { value: "gf-dmserif", label: "DM Serif Display", family: '"DM Serif Display", serif', group: "Editorial & script", googleFamily: "DM Serif Display" },
  { value: "gf-cormorant", label: "Cormorant Garamond", family: '"Cormorant Garamond", serif', group: "Editorial & script", googleFamily: "Cormorant Garamond" },
  { value: "gf-bodoni", label: "Bodoni Moda (fashion)", family: '"Bodoni Moda", serif', group: "Editorial & script", googleFamily: "Bodoni Moda" },
  { value: "gf-satisfy", label: "Satisfy (hand-painted)", family: '"Satisfy", cursive', group: "Editorial & script", googleFamily: "Satisfy" },
] as const satisfies readonly OverlayFontDefinition[];

export type FontFamily = typeof OVERLAY_FONTS[number]["value"];

const fontByValue = new Map<string, OverlayFontDefinition>(
  OVERLAY_FONTS.map((font) => [font.value, font]),
);
const loadingFonts = new Map<string, Promise<void>>();

export function isFontFamily(value: unknown): value is FontFamily {
  return typeof value === "string" && fontByValue.has(value);
}

export function resolveOverlayFontFamily(value: FontFamily): string {
  return fontByValue.get(value)?.family ?? fontByValue.get("sans")!.family;
}

export function populateOverlayFontSelect(select: HTMLSelectElement): void {
  const groups = new Map<string, HTMLOptGroupElement>();
  select.replaceChildren();
  for (const font of OVERLAY_FONTS) {
    let group = groups.get(font.group);
    if (!group) {
      group = document.createElement("optgroup");
      group.label = font.group;
      groups.set(font.group, group);
      select.appendChild(group);
    }
    const option = document.createElement("option");
    option.value = font.value;
    option.textContent = font.label;
    option.style.fontFamily = font.family;
    group.appendChild(option);
  }
}

export function ensureOverlayFontLoaded(value: FontFamily): Promise<void> {
  const font = fontByValue.get(value);
  if (!font?.googleFamily || typeof document === "undefined") {
    return Promise.resolve();
  }
  const googleFamily = font.googleFamily;
  const existing = loadingFonts.get(value);
  if (existing) return existing;
  const promise = new Promise<void>((resolve) => {
    const id = `pulsefx-font-${value}`;
    let link = document.getElementById(id) as HTMLLinkElement | null;
    const finish = (): void => {
      void document.fonts?.load(`16px "${font.googleFamily}"`).finally(resolve);
    };
    if (link) {
      finish();
      return;
    }
    link = document.createElement("link");
    link.id = id;
    link.rel = "stylesheet";
    link.href = `https://fonts.googleapis.com/css2?family=${googleFamily.trim().split(/\s+/).join("+")}&display=swap`;
    link.addEventListener("load", finish, { once: true });
    link.addEventListener("error", () => resolve(), { once: true });
    document.head.appendChild(link);
  });
  loadingFonts.set(value, promise);
  return promise;
}